import { useTranslation } from "react-i18next"
import { Button, ButtonList, MainContentPaddingTypes, NewModal, Overlay, PageHeader, ToggleBox } from "../../../../Components"
import { colors, fonts, frames, glyphs, images, useMediaQuery } from "../../../../Styles"
import { Pages } from "../../../../Navigation/Routers/root"
import { useMemo, useState } from "react"
import { EsfLocation, TestData as esfSections } from "../../../../Services/Agrisys_GqlDataCaller/WalkThroughDataCalls/getEsfStructureCall"
import { ButtonTypes } from "../../../../Definitions"
import EsfSectionModal from "../../../../Components/EsfWalkThrough/Modals/esf_sectionModal"
import EsfStationModal from "../../../../Components/EsfWalkThrough/Modals/esf_stationModal"
import { EsfSectionBasic } from "../../../../Components/EsfWalkThrough/Station/esfBasic"
import { EsfSectionAttention } from "../../../../Components/EsfWalkThrough/Station/esfAttention"

const systemName = "sow unit"

export default function Freeda_esf_sections() {
  const { t } = useTranslation()
  const mobileXs = useMediaQuery(`(max-width: 450px)`);
  const [attention, setAttention] = useState<boolean>(true)
  const [editTable, setEditTable] = useState<boolean>(false)
  const [isHoveredSection, setHoveredSection] = useState<number | null>(null);
  
  const [camModal, setCamModal] = useState<boolean>(false)
  const [newSectionModal, setNewSectionModal] = useState(false)

  const [activeSectionId, setActiveSectionId] = useState<number | null>(null);
  const [activeStation, setActiveStation] = useState<EsfLocation | undefined>();

  const sections = useMemo(() => esfSections, []); // TODO: get sections from GraphQL
  // const sections = useMemo(() => (esfSectionsState[domain] ? esfSectionsState[domain].data: undefined),[domain, esfSectionsState])

  // Extract section IDs from Sections data
  const sectionIds = useMemo(() => (sections?.map((esfSection) => esfSection.section_id) ?? [0]),[sections]);
  const firstSectionId = sectionIds[0];
  const lastSectionId = sectionIds[sectionIds.length - 1];

  // Switch between edit mode and non-edit mode
  const switchTable = () => {
    setEditTable((editTable) => !editTable);
    setAttention(false)
  };

  // #region | Active Section and Station handling
  // useEffect(() => {
  //   setActiveStation((old) => {
  //     if (old) {
  //       const location = esfSections?.flatMap((section) => (section.section_locations)).find((location) => (location.location_id === old.location_id));
        
  //       if (location) {
  //         return {...location};
  //       }
  //       return undefined;
  //     }
  //     return old
  //   })
  // }, [esfSections])
  // #endregion
  
  // Sections Info
  const sectionInfo = useMemo(() => {
    if (!sections) return { currentSectionIndex: -1, currentSectionName: "", currentSectionStations: [] };
    const currentSectionIndex = sections.findIndex(s => s.section_id === activeSectionId);
    const currentSectionName = sections?.[currentSectionIndex]?.name
    const currentSectionStations = sections?.[currentSectionIndex]?.section_locations ?? [];

    return {
      currentSectionIndex,
      currentSectionName,
      currentSectionStations
    }
  }, [activeSectionId, sections])

  // Station Info
  const stationInfo = useMemo(() => {
    if (!sectionInfo) return { currentStationIndex: -1, currenStationName: "" };
    const currentStationIndex = sectionInfo.currentSectionStations.findIndex(station => station.location_id === activeStation?.location_id);
    const currenStationName = sectionInfo.currentSectionStations?.[currentStationIndex]?.name
    
    return {
      currentStationIndex,
      currenStationName
    }
  }, [activeStation?.location_id, sectionInfo])

  // Handle station selection from SectionModal
  function handlePenSelected(penId: number) {
    setActiveStation(sectionInfo?.currentSectionStations.find((station) => station.location_id === penId)); 
  }

  return (
    <frames.Page_inner>
      <frames._page_inner_header>
        <PageHeader
          topHeader={systemName}
          subHeader={t(`menuHeaders.${Pages.freeda_esf_sections}`, {defaultValue: "sections"})}
        />
      </frames._page_inner_header>
      <frames._page_inner_content style={{zIndex: editTable ? "9999" : "0"}}>
        <frames._grid_topBtns_outer>
          <frames._grid_topBtns_inner>
            <p style={{ ...fonts.header, ...fonts.fontSize3, color: colors.greyLightTertiary, marginBottom: "5px" }}>{t("locationFeederPages.sections.section", {defaultValue: "section"})} {firstSectionId} {t("to", {defaultValue: "to"})} {lastSectionId}</p>
            {!editTable? 
              <ButtonList 
                contents={[t("buttons.add", {defaultValue: "add"}), t("buttons.edit", {defaultValue: "edit"})]} 
                onClick={(i => {
                  if (i === 0) {setNewSectionModal(true)}
                  else if (i === 1) switchTable()
                })}
                buttonType={ButtonTypes.tableButton}
                startEnhancers={[glyphs.Add({}), glyphs.Edit({})]}
              />
            : <ButtonList 
                contents={[t("buttons.save", {defaultValue: "save"}), t("buttons.cancel", {defaultValue: "cancel"}),t("buttons.add", {defaultValue: "add"}), t("buttons.edit", {defaultValue: "edit"})]} 
                onClick={(i => {
                  if (i === 0) {}
                  else if (i === 1) switchTable()
                })}
                buttonType={ButtonTypes.tableButton}
                startEnhancers={[glyphs.Check({}), glyphs.Close({}), glyphs.Add({}), glyphs.Edit({})]}
                disabled={[false, false, true, true]}
                overrides={(index) => ({
                  baseButton: {
                    backgroundColor: index === 3 ? colors.greyPrimary : colors.greySecondary
                  },
                  disabledStyles: {
                    opacity: index === 3 ? 1 : 0.5
                  }
                })}
              />
            }
          </frames._grid_topBtns_inner>
          <frames.Grid_oneRow>
        <frames._grid_oneRow_top>
          <frames._grid_top_toggleBox_container style={{ columnGap: mobileXs ? "10px" : "30px" }}>
            <ToggleBox disabled={editTable? true : false} text={t("systemControls.general.attentions", {defaultValue: "attentions"})} icon={<div style={{marginTop: "1px"}}><glyphs.Attention size="17px"/></div>} onChange={() => setAttention(attention ? false : true)} isChecked={attention ? true : false}/>
          </frames._grid_top_toggleBox_container>
        </frames._grid_oneRow_top>
        <frames._grid_oneRow_content style={{ justifyContent: mobileXs ? "center" : "start" }}>
          <frames._grid_camButton_container>
            <Button content=''
              startEnhancer={glyphs.Cam({size: "40px"})}
              overrides={{
                baseButton: {width: "50px", backgroundColor: colors.greySecondary},
                startEnhancerStyles: {margin: "0px"},
                hoverStyles: {backgroundColor: colors.greyPrimary}
              }}
              onClick={() => setCamModal(true)}
              disabled={editTable ? true : false}
            />
          </frames._grid_camButton_container>
          {Array.isArray(esfSections) && esfSections.map(({ section_id: sectionId, section_locations: stations, name }) => (
            <frames._grid_section_frame
              key={sectionId}
              onClick={() => { setActiveSectionId(sectionId)}}
              style={{ filter: isHoveredSection === sectionId ? 'opacity(0.5)' : 'opacity(1)' }}
              onMouseEnter={() => setHoveredSection(sectionId)}
              onMouseLeave={() => setHoveredSection(null)}
            >
              <p style={{...fonts.header, ...fonts.fontSize3, color: colors.greyDarkPrimary, textAlign: "center", marginBottom: "10px"}}>{name}</p>
              {attention
              ? <EsfSectionAttention
                  sectionId={sectionId}
                  stations={stations}
                />  
              : <EsfSectionBasic
                  sectionId={sectionId}
                  stations={stations}
                /> 
              }
              <div style={{ position: "absolute", top: 0, right: 0 }}><glyphs.Corner fillColor={colors.greyTertiary} rotate={90} /></div>
              <div style={{position: "absolute", bottom: 0, right: 0}}><glyphs.Corner fillColor={colors.greyTertiary} rotate={180}/></div>
              <div style={{position: "absolute", bottom: 0, left: 0}}><glyphs.Corner fillColor={colors.greyTertiary} rotate={270}/></div>
              <div style={{position: "absolute", top: 0, left: 0}}><glyphs.Corner fillColor={colors.greyTertiary}/></div>
            </frames._grid_section_frame>
          ))}
        </frames._grid_oneRow_content>
          </frames.Grid_oneRow>
        </frames._grid_topBtns_outer>
      </frames._page_inner_content>

      {/* Section/Station Modal */}
      {(activeSectionId || activeStation) &&
        <NewModal
          modalState={activeSectionId !== null || activeStation !== undefined}
          header={activeStation !== undefined ? `${t("locationFeederPages.locationFeeder.pen", { defaultValue: "Pen" })} ${stationInfo.currenStationName}` : sectionInfo.currentSectionName}
          subHeader={activeStation !== undefined ? `${systemName} ${sectionInfo.currentSectionName}` : `${systemName}`}
          overrides={{
            backgroundColor: colors.greyLightTertiary,
            mainContentPadding: MainContentPaddingTypes.primary,
            mainContentScroll: true
          }}
          predefinedButtons={{
            onClose: () => {
              setActiveSectionId(null)
              if (activeStation !== undefined) setActiveStation(undefined)
            },
            onGoBack: activeStation !== undefined ? () => setActiveStation(undefined) : undefined,
            onPrev: () => activeStation !== undefined
              ? setActiveStation(sectionInfo.currentSectionStations[(stationInfo.currentStationIndex - 1 + sectionInfo.currentSectionStations?.length) % sectionInfo.currentSectionStations.length])
              : setActiveSectionId(sectionIds[(sectionInfo.currentSectionIndex - 1 + sectionIds.length) % sectionIds.length]),
            onNext: () => activeStation !== undefined
              ? setActiveStation(sectionInfo.currentSectionStations[(stationInfo.currentStationIndex + 1) % sectionInfo.currentSectionStations.length])
              : setActiveSectionId(sectionIds[(sectionInfo.currentSectionIndex + 1) % sectionIds.length])
          }}
          mainContent={
            <div style={{ width: "650px" }}>
              {activeStation === undefined && activeSectionId !== null ?
                  <EsfSectionModal activeSectionId={activeSectionId} onStationSelected={handlePenSelected} stations={sectionInfo.currentSectionStations} /> // SECTION POPUP
                : activeStation !== null ? <>
                  <EsfStationModal activeStation={activeStation}/>
                </> : null
              }
            </div>
          }
        />
      }

      {/* Cam Modal à la stable overview/image */}
      {editTable && <Overlay/>}
      {camModal && (
        <NewModal
          modalState={true}
          predefinedButtons={{ onClose: () => setCamModal(false) }}
          header={`${systemName} ${t("locationFeederPages.sections.map",{defaultValue: "map"})}`}
          mainContent={ <img src={images.systemView} alt={`${systemName} ${t("locationFeederPages.sections.map",{defaultValue: "map"})}`} style={{ width: "100%", borderRadius: "0px 0px 10px 10px" }} /> }
        />
      )}
    
      {/* New Section Modal */}
      {newSectionModal && (
        <></>
      )}

    </frames.Page_inner>
  )
}